import { IAbUseExperiment } from '../../types/abUseExperiments';

export const HOUSE_CARD_URL_EXPERIMENT = 'audience_house_card_url';

export const isHouseCardUrlExperimentActive = (experiments: IAbUseExperiment[]): boolean => {
  const experiment = experiments.find(exp => exp.experimentName === HOUSE_CARD_URL_EXPERIMENT);

  return Boolean(experiment && experiment.groupName === 'B');
};
